import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { HttpUtil } from '../../utils/http-util';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class NonceService {

    constructor(
        private http: HttpClient
    ) { }

    getNonce(senderId: string): Observable<any> {
        const headerParams = {
            'sender-id': senderId
        };
        const url = environment.base_url + '/v1.0.0/auth/get-nonce';
        return this.http.get(url, HttpUtil.getHttpOptions(headerParams)).pipe(
            map(HttpUtil.extractData),
            catchError(HttpUtil.handleErrorObservable)
        );
    }

}
